import React from "react";
import {useLocation} from "react-router-dom";
import {NavLink} from "react-router-dom";
import {checkIsActive} from "../../../../_helpers";
import {FaMoneyCheck} from "react-icons/fa";
import {TiTicket} from "react-icons/ti";
import {CgFileDocument} from "react-icons/cg";
import {FaTicketAlt, FaUser} from "react-icons/fa";
import LoopIcon from "@material-ui/icons/Loop";
import SportsSoccerIcon from '@material-ui/icons/SportsSoccer';
import useAuth from "app/hooks/useAuth";

export function AsideMenuList({layoutProps}) {
    const location = useLocation();
    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu &&
            "menu-item-active"} menu-item-open menu-item-not-hightlighted`
            : "";
    };

    const {isSuperAgent} = useAuth();

    return (
        <>
            {/* begin::Menu Nav */}
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/transactions",
                        true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                >
                    <NavLink className="menu-link menu-toggle" to="/transactions/*">
                        <span className="svg-icon menu-icon">
                            <FaMoneyCheck/>
                        </span>
                        <span className="menu-text">Tranzaksiyalar</span>
                        <i className="menu-arrow"/>
                    </NavLink>
                    <div className="menu-submenu ">
                        <i className="menu-arrow"/>
                        <ul className="menu-subnav">
                            <li
                                className="menu-item  menu-item-parent"
                                aria-haspopup="true"
                            >
                            </li>
                            <li
                                className={`menu-item menu-item-submenu ${getMenuItemActive(
                                    "/transactions/ticket",
                                    true
                                )}`}
                                aria-haspopup="false"
                                data-menu-toggle="hover"
                            >
                                <NavLink
                                    className="menu-link menu-toggle"
                                    to="/transactions/ticket"
                                >
                      <span className="svg-icon menu-icon">
                          <FaTicketAlt/>
                      </span>
                                    <span className="menu-text">Bilet tranzaksiyaları</span>
                                </NavLink>
                            </li>
                            <li
                                className={`menu-item menu-item-submenu ${getMenuItemActive(
                                    "/transactions/agent",
                                    true
                                )}`}
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                            >
                                <NavLink
                                    className="menu-link menu-toggle"
                                    to="/transactions/agent"
                                >
                      <span className="svg-icon menu-icon">
                          <FaUser/>
                      </span>
                                    <span className="menu-text">Agent tranzaksiyaları</span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </li>
                <li
                    className={`menu-item  ${getMenuItemActive("/tickets", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/tickets">
                    <span className="svg-icon menu-icon">
                        <TiTicket/>
                    </span>
                        <span className="menu-text">Bileti ödə/ləğv et</span>
                    </NavLink>
                </li>
                <li
                    className={`menu-item  ${getMenuItemActive("/circulations", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/circulations">
                    <span className="svg-icon menu-icon">
                        <LoopIcon/>
                    </span>
                        <span className="menu-text">Turlar</span>
                    </NavLink>
                </li>
                {!isSuperAgent && (
                    <li
                        className={`menu-item  ${getMenuItemActive("/play", false)}`}
                        aria-haspopup="true"
                    >
                        <NavLink className="menu-link" to="/play">
                    <span className="svg-icon menu-icon">
                        <SportsSoccerIcon/>
                    </span>
                            <span className="menu-text">Mərc et</span>
                        </NavLink>
                    </li>
                )}
                <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                        "/reports",
                        true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                >
                    <NavLink className="menu-link menu-toggle" to="/reports/*">
                        <span className="svg-icon menu-icon">
                            <CgFileDocument/>
                        </span>
                        <span className="menu-text">Hesabatlar</span>
                        <i className="menu-arrow"/>
                    </NavLink>
                    <div className="menu-submenu ">
                        <i className="menu-arrow"/>
                        <ul className="menu-subnav">
                            <li
                                className="menu-item  menu-item-parent"
                                aria-haspopup="true"
                            >
                            </li>
                            <li
                                className={`menu-item menu-item-submenu ${getMenuItemActive(
                                    "/reports/daily-report",
                                    true
                                )}`}
                                aria-haspopup="false"
                                data-menu-toggle="hover"
                            >
                                <NavLink
                                    className="menu-link menu-toggle"
                                    to="/reports/daily-report"
                                >
                      <span className="svg-icon menu-icon">
                          <CgFileDocument/>
                      </span>
                                    <span className="menu-text">Günlük hesabat</span>
                                </NavLink>
                            </li>
                            <li
                                className={`menu-item menu-item-submenu ${getMenuItemActive(
                                    "/reports/weekly-report",
                                    true
                                )}`}
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                            >
                                <NavLink
                                    className="menu-link menu-toggle"
                                    to="/reports/weekly-report"
                                >
                      <span className="svg-icon menu-icon">
                          <CgFileDocument/>
                      </span>
                                    <span className="menu-text">Həftəlik hesabat</span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
            {/* end::Menu Nav */}
        </>
    );
}
